import React from 'react';
import PropTypes from 'prop-types';
import { Buttons } from 'lidya-common-components';
import { Trans } from 'gatsby-plugin-react-i18next';
import { ContextLink } from '../../../common/contextLink';

export function HomeButton({ slug, newTab }) {
  return (
    <ContextLink
      to={slug}
      id={`ActionButtonHome${slug}`}
      className="a-navigation__goHomeButton"
      target={newTab ? '_blank' : undefined}
    >
      <Buttons.Button
        type={Buttons.BUTTON_TYPES.SECONDARY}
        onClick={() => {}}
      >
        <Trans>web.404.button</Trans>
      </Buttons.Button>
    </ContextLink>
  );
}

HomeButton.propTypes = {
  slug: PropTypes.string.isRequired,
  newTab: PropTypes.bool,
};

HomeButton.defaultProps = {
  newTab: false,
};

export default HomeButton;
